import React from 'react'

const money = new Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN'})
const percentage = new Intl.NumberFormat('es-MX', {maximumFractionDigits: 4})

function OrderPriceBreakdown({product}) {
  const hasSnapshot = product.versionCalculoPrecio !== null && product.precioLista !== null
  if (!hasSnapshot) {
    return <div className='order-price-breakdown order-price-breakdown-legacy'>
      <div className='order-price-final'><span>Precio final</span><strong>{money.format(product.precioUnitario)}</strong></div>
      <small>Desglose no disponible para este pedido.</small>
    </div>
  }

  const hasProductDiscount = Number(product.descuentoProductoPorcentaje) > 0 && Number(product.descuentoProductoImporte) > 0
  const hasDistributorDiscount = product.aplicoDescuentoDistribuidor && Number(product.descuentoDistribuidorPorcentaje) > 0 && Number(product.descuentoDistribuidorImporte) > 0
  const promotion = hasProductDiscount && product.promo ? String(product.promo).trim() : ''

  return <div className='order-price-breakdown'>
    <div><span>Precio de lista</span><b>{money.format(product.precioLista)}</b></div>
    {hasProductDiscount && <>
      <div className='order-price-discount'><span>Desc. producto ({percentage.format(product.descuentoProductoPorcentaje)}%){promotion && <small className='order-price-promo'> · {promotion}</small>}</span><b>−{money.format(product.descuentoProductoImporte)}</b></div>
      <div><span>Precio con descuento</span><b>{money.format(product.precioDespuesDescuentoProducto)}</b></div>
    </>}
    {hasDistributorDiscount && <div className='order-price-discount'><span>Desc. distribuidor ({percentage.format(product.descuentoDistribuidorPorcentaje)}%)</span><b>−{money.format(product.descuentoDistribuidorImporte)}</b></div>}
    <div className='order-price-final'><span>Precio final</span><strong>{money.format(product.precioUnitario)}</strong></div>
  </div>
}

export {OrderPriceBreakdown}
